/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecipientRoleEnum } from './recipientRoleEnum';
import { CommunicationStatusEnum } from './communicationStatusEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface CommunicationRecipient { 
    readonly address: string;
    readonly role: RecipientRoleEnum;
    readonly status: CommunicationStatusEnum;
    readonly errorText: string;
}
export namespace CommunicationRecipient {
}

export const CommunicationRecipient_address_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationRecipient_role_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationRecipient_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CommunicationRecipient_errorText_Validators: ValidatorFn[] =
    [  Validators.required, ];


